import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './groupConfigWarning.module.scss';

/**
 * Warning banner shown when editing config on a branch that belongs to a multi-branch group.
 * Renders nothing unless `branch.is_grouped === true && branch.group_branch_count > 1`.
 *
 * Props:
 *   - branch: object with optional `is_grouped` (bool) and `group_branch_count` (number)
 *   - variant: 'banner' (default) or 'inline'
 *   - children: optional override for the message body. Receives no args.
 */
export default function GroupConfigWarning({ branch, variant = 'banner', children }) {
    const { t } = useTranslation();

    const count = branch?.group_branch_count ?? 0;
    if (!branch?.is_grouped || count <= 1) {
        return null;
    }

    const className = variant === 'inline' ? styles.inline : styles.banner;

    return (
        <div className={className}>
            <span className={styles.icon}>&#9432;</span>
            <div className={styles.text}>
                {children != null ? children : t('groupWarning.banner', { count })}
            </div>
        </div>
    );
}
